import { Bot, Cpu, KeyRound, ShieldAlert, Workflow } from 'lucide-react'
import { Avatar } from '@/components/ui/avatar'
import { formatDateTime, formatRelative, humanizeAction } from '@/lib/format'
import type { AuditLog } from '@/types/api'

export function actorLabel(log: AuditLog): string {
  if (log.actor) return log.actor.name
  if (log.actor_type === 'flow' && log.actor_name) return log.actor_name
  switch (log.actor_type) {
    case 'system':
      return 'System'
    case 'player':
      return 'Player'
    case 'api_key':
      return 'API key'
    case 'platform_admin':
      return 'Signetix support'
    case 'flow':
      return 'Signetix Flow'
    default:
      return 'Unknown'
  }
}

export function ActorAvatar({ log, className = 'size-8' }: { log: AuditLog; className?: string }) {
  if (log.actor && log.actor_type === 'user') return <Avatar name={log.actor.name} className={className} />
  const Icon = log.actor_type === 'player' ? Cpu : log.actor_type === 'api_key' ? KeyRound : log.actor_type === 'platform_admin' ? ShieldAlert : log.actor_type === 'flow' ? Workflow : Bot
  return (
    <span className={`flex shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground ${className}`}>
      <Icon className="size-4" />
    </span>
  )
}

export function ActivityItem({ log }: { log: AuditLog }) {
  return (
    <li className="flex items-start gap-3 py-3">
      <ActorAvatar log={log} />
      <div className="min-w-0 flex-1">
        <p className="text-sm leading-snug">
          <span className="font-medium">{actorLabel(log)}</span> <span className="text-muted-foreground">{humanizeAction(log.action).toLowerCase()}</span>
          {log.resource_type && <span className="text-muted-foreground"> · {log.resource_type}</span>}
        </p>
        <time dateTime={log.created_at} title={formatDateTime(log.created_at)} className="text-xs text-muted-foreground">
          {formatRelative(log.created_at)}
        </time>
      </div>
    </li>
  )
}
